import { render } from "./TableContent.vue?vue&type=template&id=33b2aa34&scoped=true"
import script from "./TableContent.vue?vue&type=script&lang=js"
export * from "./TableContent.vue?vue&type=script&lang=js"

import "./TableContent.vue?vue&type=style&index=0&id=33b2aa34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b2aa34"]])

export default __exports__